"use strict";
import { Flex } from "ui/src";
import {
  getWarningIcon,
  getWarningIconColors,
  safetyLevelToWarningSeverity
} from "components/warnings/utils";
export default function WarningIcon({
  safetyLevel,
  severity,
  strokeColorOverride,
  heroIcon,
  inModal,
  ...rest
}) {
  const severityToUse = severity ?? safetyLevelToWarningSeverity(safetyLevel);
  const { color: defaultIconColor, backgroundColor, inModalColor } = getWarningIconColors(severityToUse);
  const color = strokeColorOverride ?? defaultIconColor;
  const Icon = getWarningIcon(severityToUse);
  const icon = Icon ? <Icon color={inModal && inModalColor ? inModalColor : color} {...rest} /> : null;
  return heroIcon ? <Flex borderRadius="$rounded12" p="$spacing12" backgroundColor={backgroundColor}>
      {icon}
    </Flex> : icon;
}
